// La nouvelle interface, épurée (9 octobre 2026) : Explorer et le Sonar d'un
// format (`pages/epure/ESonar.vue`). Les mots du Sonar déjà écrits pour l'écran
// classique (`sonar.statut`, `sonar.mots`, `sonar.titre`, `sonar.relecture`…)
// se lisent dans `sonar` ; ne sont ici que ceux des maquettes et du choix des
// publics.
export default {
  ariane: 'Fil d’Ariane',
  explorer: {
    sousTitre: 'Une question ouverte, posée aux publics que vous choisissez',
    vosEtudes: 'Vos études',
  },
  format: {
    titre: 'Sonar',
    sousTitre: 'Une question sur {titre}, posée à ses cibles : ce qu’elles choisissent, ce qu’elles préfèrent, ce qu’elles en disent',
    poseeA: 'Posée à vos cibles, {cibles}',
    poseeAuPanel: 'Posée au panel du format',
    changer: 'changer',
    changerAria: 'Changer les cibles de {titre}',
    aucune: 'Pas encore de question sur {titre}.',
  },
  // La piste d'une lecture de passage (19 octobre 2026) : ses réponses préparées.
  piste: {
    titre: 'Les réponses préparées : {titre}',
    aide: 'Le panel choisira entre ces réponses ; décochez celles à écarter. Vous relisez encore l’étude avant de la lancer.',
    oublier: 'Ne pas les garder',
    saison: 'Ce que le panel saura de la saison',
    saisonAide: 'Des faits, sans chiffre d’audience ni avis : le panel le lit avant de répondre. Videz-le pour qu’il n’en sache rien.',
  },
  question: {
    libelle: 'Votre question',
    exemples: 'Par exemple :',
    publicRequis: 'Choisissez au moins un public à interroger.',
  },
  heure: {
    libelle: 'Interroger comme le',
    maintenant: 'Maintenant',
    revenir: 'Revenir à maintenant',
    passee: 'Les jumeaux répondent comme à cet instant.',
    avenir: 'L’étude partira à cette heure.',
    commeLe: 'Comme le {quand}',
    partira: 'Elle partira le {quand}.',
  },
  publics: {
    libelle: 'À qui la poser',
    choisis: 'Choisis :',
    aucun: 'Aucun public choisi pour l’instant.',
    compte: '{n} sur {max} au plus',
    toutRetirer: 'Tout retirer',
    retirer: 'Retirer {nom}',
    rechercher: 'Rechercher',
    rechercherDans: 'Rechercher parmi : {famille}',
    aucunResultat: 'Aucun public ne correspond.',
    maximum: '{max} publics au plus : retirez-en un pour en choisir un autre.',
    termine: 'Terminé',
    choisisDans: 'aucun choisi | {n} choisi | {n} choisis',
    chargement: 'Les publics se lisent…',
    illisibles: 'Les publics n’ont pas pu se lire.',
    fermes: 'Le choix des publics n’est pas ouvert à votre compte.',
    aucunOuvert: 'Aucun public interrogeable n’est encore ouvert à votre compte.',
    famille: {
      // Les villes de la simulation : leurs jumeaux répondent (4 novembre 2026).
      simulation: 'Villes',
      pays: 'Pays',
      chaine: 'Chaînes',
      plateforme: 'Plateformes',
      jeunes: 'Publics jeunes',
      thematique: 'Verticales',
      // L'électorat d'un pays, pour qui a Polis (11 octobre 2026).
      politique: 'Politique',
      programme: 'Publics des programmes',
      autres: 'Autres publics',
    },
  },
  statut: {
    rendu: 'Rendue',
  },
  vote: {
    questionPosee: 'La question posée au panel',
  },
  relecture: {
    auPlus: 'Au plus {nb} dans la liste : retirez-en quelques-uns.',
  },
}
